import React, { createContext, useContext, useState, useCallback } from "react";

/**
 * Search context global — o header tem um campo de busca que é compartilhado
 * por várias telas (tickets, kanban, contatos). Cada tela consome via useSearch
 * e reage ao ticketSearchParam mudar.
 */
const SearchContext = createContext({
  ticketSearchParam: "",
  setTicketSearchParam: () => {},
  searchOnMessages: false,
  setSearchOnMessages: () => {},
  clear: () => {},
});

export const SearchProvider = ({ children }) => {
  const [ticketSearchParam, setTicketSearchParam] = useState("");
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const clear = useCallback(() => {
    setTicketSearchParam("");
    setSearchOnMessages(false);
  }, []);

  return (
    <SearchContext.Provider
      value={{
        ticketSearchParam,
        setTicketSearchParam,
        searchOnMessages,
        setSearchOnMessages,
        clear,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);

export default SearchContext;
